import {
  useCallback,
} from 'react';
import {
  FileLocalUrl,
} from 'pages/Dashboard/components/FilePicker';
import {
  useUploadInsuranceAttachments,
} from 'views/EMR/components/Insurance/hooks';

type Params = {
  insuranceId?: number;
  patientId?: number;
  onUploadSuccess: () => Promise<unknown> | void;
};

export default function useInsuranceAttachmentUpload({
  insuranceId,
  patientId,
  onUploadSuccess,
}: Params) {
  const {
    uploadAllInsuranceAttachments,
    isPending,
  } = useUploadInsuranceAttachments();

  const isDisabled = (insuranceId ?? 0) <= 0
    || (patientId ?? 0) <= 0
    || isPending;

  const uploadFiles = useCallback(async (files: FileLocalUrl[]) => {
    if ((insuranceId ?? 0) > 0 && (patientId ?? 0) > 0 && files.length > 0) {
      await uploadAllInsuranceAttachments({
        insuranceId: insuranceId ?? 0,
        patientId: patientId ?? 0,
        files,
      });
      await onUploadSuccess();
    }
  }, [
    insuranceId,
    onUploadSuccess,
    patientId,
    uploadAllInsuranceAttachments,
  ]);

  return {
    uploadFiles,
    isDisabled,
    isUploading: isPending,
  };
}
